import { Button, Tooltip } from '@cambridgeassessment/cambridge-ui';
import { Add } from '@material-ui/icons';
import React, { memo } from 'react';
import { EMAIL_LIMIT } from './constants';
import { buttonStyles as useStyles } from './styles';

type Props = {
  disabled?;
  onClick: () => void;
};

const AddButton: React.FC<Props> = ({ disabled, onClick }) => {
  const classes = useStyles();
  return disabled ? (
    <Tooltip
      border="light"
      title={`You may only associate a maximum of ${EMAIL_LIMIT} email addresses to your profile, to add another you will need to remove one of the emails above.`}
      detailed
    >
      <span>
        <Button
          disabled={disabled}
          variant="outlined"
          className={classes.buttonn}
          size="large"
          startIcon={<Add />}
          data-testid="addEmail-add"
        >
          Add another email address
        </Button>
      </span>
    </Tooltip>
  ) : (
    <span>
      <Button
        variant="outlined"
        className={classes.buttonn}
        size="large"
        onClick={onClick}
        startIcon={<Add />}
        data-testid="addEmail-add"
      >
        Add another email address
      </Button>
    </span>
  );
};

export default memo(AddButton);
